import { nanoId } from '@/helpers'
import Vue from 'vue'

export const SET_BASE = (state, value) => {
  state.base = value
}

export const SET_DATE = (state, { key, value }) => {
  state._[key].date = value
}

export const SET_AMOUNT = (state, { key, value }) => {
  state._[key].amount = value
}

export const ADD = (state, payload) => {
  let key = nanoId(8)
  state.list.push(key)
  Vue.set(state._, key, payload)
}

export const DELETE = (state, key) => {
  if (key === 'mandatory') {
    state._['mandatory'].date = undefined
    state._['mandatory'].amount = undefined
    return
  }
  state.list = state.list.filter(k => k !== key)
  delete state._[key]
}
